import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { KazooMetadata } from '../models/company.model';
import { Pbx } from '../models/pbx.model';
import { CallRecordingConfiguration } from '../../subscription/models';

@Injectable()
export class PbxService {
  constructor(private http: HttpClient) { }

  getPivotStatus(pbxId: number) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/pivot/status`);
  }

  setPivot(pbxId: number, value: { inbound: string, outbound: string }) {
    return this.http.put(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/pivot/toggle`, value)
  }

  getPivotConfig(pbxId: number) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/pivot/config`)
  }

  toggleChannelLimit(pbxId: number, param?: string) {
    let params = new HttpParams();
    if(param) {
      params = params.append('notification_type', 'slack_internal')
    }
    return this.http.put(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/pivot/channel-limit-notifications/toggle`, null, { params })
  }

  getPbxes(pbxId: number) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}`);
  }

  updatePbx(pbx: Pbx): Observable<Pbx> {
    return this.http.put<Pbx>(`${environment.apiEndpoint}/api/v1/pbxes/${pbx.id}`, pbx);
  }

  getKazooMetadata(): Observable<KazooMetadata> {
    return this.http.get<KazooMetadata>(`${environment.apiEndpoint}/api/v1/pbxes/kazoo`);
  }

  getLinkToKazoo(pbxId: number) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/kazoo/ui`, { responseType: 'text' });
  }

  updateCallRecordingConfiguration(pbxId: number, callRecordingConfiguration: CallRecordingConfiguration) {
    return this.http.put<CallRecordingConfiguration>(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/call-recording-configuration`, callRecordingConfiguration);
  }
}
